import type { Localized } from './types';

/**
 * "Tools we recommend" — a paid option and a free one, side by side, our own
 * free tools always first (Rod, 2026-09-10). Same list as the app, by value.
 *
 * 🔑 The QuickBooks link becomes the Intuit affiliate tracking link once Rod's
 * account is approved — set `VITE_AFFILIATE_QUICKBOOKS_URL` per env. Until
 * then it is the plain product page, and the disclosure still shows, because
 * the arrangement is the thing being disclosed, not the URL. (Rod 2026-09-11:
 * the link itself is parked; the block is not.)
 *
 * 🛑 Shown only on the Recordkeeping and Taxes 101 guides — the two places a
 * Runner is deciding how to track money. Never on safety or pay-statement
 * guides; a recommendation there would read as a sales pitch in the wrong room.
 */
export interface RecommendedTool {
  key: string;
  name: string;
  paid: boolean;
  url: string;
  blurb: Localized<string>;
}

const QUICKBOOKS_PLAIN = 'https://quickbooks.intuit.com/solopreneur/';

export const RECOMMENDED: RecommendedTool[] = [
  {
    key: 'quickbooks',
    name: 'QuickBooks Solopreneur',
    paid: true,
    url: ((import.meta.env.VITE_AFFILIATE_QUICKBOOKS_URL as string | undefined) ?? '').trim() || QUICKBOOKS_PLAIN,
    blurb: {
      en: 'Mileage, expense categories and a quarterly-tax estimate, built for 1099 work.',
      es: 'Millas, categorías de gastos y una estimación de impuestos trimestrales, hecho para trabajo 1099.',
    },
  },
  {
    key: 'stride',
    name: 'Stride',
    paid: false,
    url: 'https://www.stridehealth.com/tax',
    blurb: { en: 'Automatic mileage tracking and expense capture. No cost.', es: 'Registro automático de millas y captura de gastos. Sin costo.' },
  },
];

/** Categories whose guides carry the block. */
export const RECOMMENDED_CATEGORIES: ReadonlySet<string> = new Set(['recordkeeping-and-money', 'taxes-101']);
